// eslint-disable-next-line
import Player from '@vimeo/player';

const $ = require('jquery');

/**
 * Adjust the video player size
 */
function videoresizing() {
    $('.lp-video').each(function () {
        const $lpVideo = $(this);
        const $playerMobile = $lpVideo.find('.lp-video-player-mobile');
        const $playerTablet = $lpVideo.find('.lp-video-player-tablet');
        const $playerDesktop = $lpVideo.find('.lp-video-player-desktop');
        const screensize = $(window).width();

        // Detach Videos
        $playerMobile.detach();
        $playerTablet.detach();
        $playerDesktop.detach();

        // Check if there is fallback image for mobile
        if ($playerTablet.find('.mobile-fallback-image').length !== 0) {
            $playerTablet.addClass('with-mobile-fallback');
        }
        if ($playerDesktop.find('.mobile-fallback-image').length !== 0) {
            $playerDesktop.addClass('with-mobile-fallback');
        }

        // Showing videos
        if (screensize < 768) {
            if ($playerMobile !== null) {
                $lpVideo.append($playerMobile);
            } else {
                $lpVideo.append($playerDesktop);
            }
        } else if (screensize < 1024) {
            if ($playerTablet !== null) {
                $lpVideo.append($playerTablet);
            } else {
                $lpVideo.append($playerDesktop);
            }
        } else {
            $lpVideo.append($playerDesktop);
        }

        // Add class to show
        $lpVideo.addClass('active-video');
    });
}

/**
 * This function is to make the video iframe resize smoothly
 */
function videoiframesize() {
    $('.lp-video-player').each(function () {
        const $videoPlayer = $(this);
        const $iframe = $videoPlayer.find('iframe');
        const iframewidth = parseInt($iframe.attr('width'));
        const iframeheight = parseInt($iframe.attr('height'));
        const calcpaddingbottomContent = (iframeheight / iframewidth) * 100 + 5; // additional 5% of padding
        const paddingbottomContent = `${calcpaddingbottomContent}%`;
        const calcpaddingbottomNocontent = (iframeheight / iframewidth) * 100;
        const paddingbottomNocontent = `${calcpaddingbottomNocontent}%`;

        // ADD Class (Necessary for the LESS logic)
        $iframe.addClass('lp-video-player-iframe');

        // Calculation for the padding bottom of the iframe wrapper div.
        // If lp-video-only is not necessary additional 5% of padding.
        if ($videoPlayer.hasClass('lp-video-only')) {
            $videoPlayer.css('padding-bottom', paddingbottomNocontent);
        } else {
            $videoPlayer.css('padding-bottom', paddingbottomContent);
        }
    });
}

/**
 * Initializes vimeo video on PDP
 * checks id the vimeo cookie allowed
 * removes the slide otherwise
 *
 * @param {JQuery} vimeoContainer - a container with deta-video-vimeo-id
 */
function initPDP(vimeoContainer) {
    const cookie = require('../components/cookie');
    cookie.isAllowed('vimeo', async isAllowed => {
        const vimeoId = vimeoContainer.data('video-vimeo-id');
        if (!vimeoId) {
            return;
        }

        const options = {
            id: vimeoId,
            maxwidth: 850,
            responsive: true
        };

        if (isAllowed) {
            // eslint-disable-next-line no-undef
            const videoPlayer = new Player(vimeoContainer.attr('id'), options);

            $('.disallowed-cookie').addClass('m-hidden');

            videoPlayer.on('loaded', function () {
                const container = vimeoContainer.parent();
                const containerHeight = container.height();
                const slickSlider = vimeoContainer.parents('.slick-list');
                const slideMargin = 10;
                const slideWithVimeo = $('#vimeoPdpVideo').parents('.slick-slide.slick-active').data('slick-index');

                vimeoContainer.height(containerHeight);
                container.height(containerHeight);

                $('.slick-dots-custom li').each(function () {
                    const dotsNumber = $(this).find('button').text();
                    if (slideWithVimeo + 1 === +dotsNumber) {
                        slickSlider.height(containerHeight + slideMargin);
                    }
                });
            });
        }
    });
}

/**
 *
 */
function initPDPTabs() {
    $('.js-vimeo-container').each(function () {
        const videoId = $(this).data('videoVimeoId');
        const options = {
            maxwidth: 850,
            responsive: true,
            controls: true,
            autopause: true,
            byline: false,
            keyboard: true
        };
        if (/^\d+$/.test(videoId)) {
            options.id = videoId;
        } else {
            options.url = videoId;
        }
        if (videoId) {
            const videoPlayer = new Player($(this).attr('id'), options);
            videoPlayer.ready().then(() => {
                videoPlayer.pause();
            });
        }
    });
}

/**
 * Initializes vimeoVideo
 */
function videovimeo() {
    videoresizing();
    videoiframesize();

    const vimeoContainer = $('#vimeoPdpVideo');
    const vimeoContainerBottom = $('#vimeoPdpVideoBottom');
    if (vimeoContainer.length) {
        initPDP(vimeoContainer);
    }

    if (vimeoContainerBottom.length) {
        initPDP(vimeoContainerBottom);
    }

    initPDPTabs();
}

module.exports = {
    init: videovimeo
};
